import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import { TrpcApiBlueprint } from '@ipen-portal/plugin-trpc-react';

import { jiraApiRef } from './apis';

export const jiraPlugin = createFrontendPlugin({
  extensions: [
    TrpcApiBlueprint.make({
      name: 'jira-api',
      params: defineParams =>
        defineParams({
          apiRef: jiraApiRef,
          path: 'solution-process',
        }),
    }),

    FormFieldBlueprint.make({
      name: 'JiraSprintPicker',
      params: {
        field: () =>
          import('./scaffolder-extensions/JiraSprintPicker').then(m =>
            createFormField({
              component: m.JiraSprintPicker,
              name: 'JiraSprintPicker',
              schema: m.JiraSprintPickerFieldSchema,
            }),
          ),
      },
    }),
  ],
  pluginId: 'jira',
});
